import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, GraduationCap, CheckCircle2, Lock, CreditCard, Users, Star, MapPin } from 'lucide-react';
export const Hero = () => {
  return <section className="relative pt-12 pb-20 lg:pt-20 lg:pb-28 overflow-hidden bg-cream" data-id="element-111">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-112">
        <div className="max-w-3xl mx-auto text-center" data-id="element-113">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center" data-id="element-114">
            <div className="inline-block bg-brand-green/10 text-brand-green font-semibold px-4 py-1.5 rounded-full text-sm mb-6 border border-brand-green/20" data-id="element-115">
              PACK DOCENTE 2026 — MATEMÁTICA PRIMARIA CFE
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-gray-900 leading-tight mb-6" data-id="element-116">
              Todo tu Año de Clases de Matemática{' '}
              <span className="text-brand-orange" data-id="element-117">Resuelto</span>
            </h1>

            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative mb-6" data-id="element-118">
              <div className="absolute inset-0 bg-brand-amber/20 rounded-full blur-3xl transform scale-90 -z-10" data-id="element-119"></div>
              <img src="https://cdn.magicpatterns.com/uploads/iw6Sg9L1mjG7Q7dyx6U23i/Diseno_sin_titulo_(4).png" alt="Pack Docente 2026 Matemática Primaria" className="w-full max-w-[48rem] mx-auto drop-shadow-2xl pt-[0px] pb-[0px] mt-[-55px] mb-[-55px]" data-id="element-120" />
            </motion.div>

            <p className="text-xl md:text-2xl font-heading font-semibold text-brand-green mb-4" data-id="element-121">
              Pack Docente 2026: Matemática Primaria CFE
            </p>

            <div className="inline-flex items-center gap-2 bg-brand-gold text-white font-bold px-4 py-2 rounded-lg mb-6 shadow-sm" data-id="element-122">
              <span className="text-xl" data-id="element-123">6 + 6</span>
              <span className="text-sm uppercase tracking-wider" data-id="element-124">
                Tomos + Bonos
              </span>
            </div>

            <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-125">
              Tu planificación anual de matemática lista para usar desde el
              lunes: secuencias didácticas, fichas imprimibles, evaluaciones y
              recursos para 1° a 6° grado.{' '}
              <span className="font-bold border-b-2 border-brand-orange" data-id="element-126">
                Sin improvisar.
              </span>
            </p>

            <div className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-127">
              <span className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-full text-sm font-medium text-gray-700 shadow-sm border border-gray-100" data-id="element-128">
                <FileText size={16} className="text-brand-orange" data-id="element-129" /> PDF Digital
              </span>
              <span className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-full text-sm font-medium text-gray-700 shadow-sm border border-gray-100" data-id="element-130">
                <Zap size={16} className="text-brand-amber" data-id="element-131" /> Acceso Inmediato
              </span>
              <span className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-full text-sm font-medium text-gray-700 shadow-sm border border-gray-100" data-id="element-132">
                <GraduationCap size={16} className="text-brand-green" data-id="element-133" /> Nivel
                Primario 1° a 6° Grado
              </span>
              <span className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-full text-sm font-medium text-gray-700 shadow-sm border border-gray-100" data-id="element-134">
                <CheckCircle2 size={16} className="text-brand-gold" data-id="element-135" /> Alineado
                NAP y CFE 2026
              </span>
            </div>

            <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} className="w-full sm:w-auto bg-brand-orange hover:bg-brand-orange/90 text-white font-bold text-lg px-8 py-4 rounded-xl shadow-soft transform transition hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-136">
              💥 QUIERO MI AÑO DE MATEMÁTICA RESUELTO AHORA
            </button>

            <div className="mt-8 flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-gray-600 font-medium" data-id="element-137">
              <span className="flex items-center gap-1.5" data-id="element-138">
                <CheckCircle2 size={16} className="text-green-600" data-id="element-139" /> Garantía 7
                días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-140">
                <Lock size={16} className="text-gray-500" data-id="element-141" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-142">
                <CreditCard size={16} className="text-blue-500" data-id="element-143" /> Mercado Pago
              </span>
              <span className="flex items-center gap-1.5" data-id="element-144">
                <Users size={16} className="text-brand-orange" data-id="element-145" /> +500 Docentes
              </span>
              <span className="flex items-center gap-1.5" data-id="element-146">
                <Star size={16} className="text-brand-gold fill-brand-gold" data-id="element-147" />{' '}
                4.9 Rating
              </span>
              <span className="flex items-center gap-1.5" data-id="element-148">
                <MapPin size={16} className="text-brand-green" data-id="element-149" /> Todo Argentina
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};